/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S7_P2Inputs */

const en_guide_large_json_files_s7_p2 = /** @type {(inputs: Guide_Large_Json_Files_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For raw size, streaming parsers read the file piece by piece instead of loading it all at once, which keeps memory flat even for files that would otherwise crash a tab. Newline-delimited JSON, where each line is its own record, makes this especially easy and lets you process a huge dataset one entry at a time. When you only need part of the data, filtering early beats loading everything and discarding most of it.`)
};

const ko_guide_large_json_files_s7_p2 = /** @type {(inputs: Guide_Large_Json_Files_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순수한 크기 문제라면, 스트리밍 파서가 파일을 한꺼번에 읽지 않고 조각조각 읽어 메모리를 낮게 유지합니다. 그렇지 않으면 탭을 멈추게 할 파일도 견딜 수 있죠. 각 줄이 하나의 레코드인 줄바꿈 구분 JSON은 이를 특히 쉽게 만들어, 거대한 데이터셋을 한 항목씩 처리하게 해줍니다. 데이터의 일부만 필요하다면, 전부 불러온 뒤 대부분 버리는 것보다 일찍 걸러내는 편이 낫습니다.`)
};

const ja_guide_large_json_files_s7_p2 = /** @type {(inputs: Guide_Large_Json_Files_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`純粋なサイズの問題なら、ストリーミングパーサーがファイルを一度に読み込まず少しずつ読み、そうでなければタブを落とすようなファイルでもメモリを低く保ちます。各行が一つのレコードである改行区切り JSON はこれを特に簡単にし、巨大なデータセットを一項目ずつ処理させてくれます。データの一部だけが必要なら、すべて読み込んで大半を捨てるより、早めに絞り込むほうがよいです。`)
};

/**
* | output |
* | --- |
* | "For raw size, streaming parsers read the file piece by piece instead of loading it all at once, which keeps memory flat even for files that would otherwise c..." |
*
* @param {Guide_Large_Json_Files_S7_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s7_p2 = /** @type {((inputs?: Guide_Large_Json_Files_S7_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S7_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s7_p2(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s7_p2(inputs)
	return ja_guide_large_json_files_s7_p2(inputs)
});